<template>
  <div class="admin-page admin-console">
    <h1>소식 관리</h1>
    
    <div class="menus">
      <vhp-select
        v-model="selectedMenu"
        :items="menus" 
        item-key="text"
        item-value="name"
        class="mr-2"
      />

      <vhp-select
        v-model="selectedLocale"
        :items="[{text:'전체', value:'ALL'},{text:'한국어', value:'KR'},{text:'ENGLISH', value:'EN'}]" 
        item-key="text"
        item-value="value"
        class="mr-2"
      />
      
      <button @click="openCreatePage" class="vhp-button mr-2" >소식 작성</button>
      <button @click="openBlogCreatePage" class="vhp-button" >블로그 생성</button>
    </div>

    <vhp-table 
      v-if="!loading && filteredList?.length > 0"
      :headers="tableHeaders"
      :items="filteredList"
    >
      <template v-slot:item-title="{item}">
        <a @click="openEditPage(item)">{{item.title}}</a>
      </template>
      <template v-slot:item-hidden="{item}">
        <button type="button" class="toggle-btn single" :class="item.hidden ? 'active' : 'inactive'" @click="setHidden(item, !item.hidden)">
          {{ item.hidden ? '활성' : '비활성' }}
        </button>
      </template>
      <template v-slot:item-registeredDate="{item}">
        {{ formatRegisteredDate(item) }}
      </template>
      <template v-slot:item-featured="{item}">
        <button type="button" class="toggle-btn single" :class="(item.featured ?? item.isFeatured) ? 'inactive' : 'active'" @click="setFeatured(item, !(item.featured ?? item.isFeatured))">
          {{ (item.featured ?? item.isFeatured) ? '비활성' : '활성' }}
        </button>
      </template>
      <template v-slot:item-action="{item}">
        <button
          v-if="item._isAiBlog"
          class="vhp-button delete-btn"
          @click="deleteAiBlog(item)"
        >삭제</button>
      </template>
    </vhp-table>
  </div>
</template>

<script>
export default {
  name: 'AdminConsole',
  data() {
    return {
      loading: true,
      menus: [
        {name: 'STORY', text: '소식 > 스토리'},
        {name: 'BLOG', text: '소식 > 블로그'},
        {name: 'NOTICE', text: '소식 > 공지사항'},
        {name: 'RESOURCE', text: '소식 > 자료실'},
      ],
      selectedMenu: 'STORY',
      selectedLocale: 'KR',
      activeList: [],
    }
  },

  computed:{
    tableHeaders() {
      return [
        { text: '제목', value: 'title', width: 200 },
        { text: '숨김', value: 'hidden' },
        { text: '조회수', value: 'viewCount' },
        { text: '등록일', value: 'registeredDate' },
        { text: '추천', value: 'featured' },
        { text: '관리', value: 'action' }
      ]
    },
    filteredList(){
      return this.activeList?.filter(item => item.category === this.selectedMenu)
        .filter(item => {
          if (this.selectedLocale === 'ALL') return true
          const itemLocale = typeof item.locale === 'object' ? item.locale?.name : item.locale
          return itemLocale === this.selectedLocale
        })
    },
  },
  methods:{
    async getNewsContents() {
      this.loading = true;

      const [contentResult, aiBlogResult] = await Promise.allSettled([
        this.$axios.get('/content?category=STORY&category=BLOG&category=NOTICE&category=RESOURCE&locale=KR&locale=EN'),
        this.$axios.get('/api/aiblog?locale=ALL')
      ])

      const contentItems = contentResult.status === 'fulfilled' ? contentResult.value.data : []
      const aiBlogItems  = aiBlogResult.status  === 'fulfilled'
        ? aiBlogResult.value.data.map(item => ({
            ...item,
            category: 'BLOG',   // filteredList의 category 필터 호환
            locale: item.locale || (item.meta && item.meta.locale) || 'KR',
            _isAiBlog: true
          }))
        : []

      this.activeList = [...contentItems, ...aiBlogItems]
      this.loading = false;
    },

    openEditPage(item){
      if (item._isAiBlog) return
      this.$router.push({name: 'adminContent', params: {type: 'edit', id: item.id}})
    },

    async deleteAiBlog(item) {
      if (!confirm(`"${item.title}" 을(를) 삭제하시겠습니까?`)) return
      try {
        await this.$axios.delete('/api/aiblog', { params: { id: item.id } })
        this.activeList = this.activeList.filter(i => i.id !== item.id)
      } catch (err) {
        alert('삭제 중 오류가 발생했습니다.')
        console.error(err)
      }
    },
    formatRegisteredDate(item) {
      const raw = item.makedate || item.createdDate || item.editedDate || item.editedDateTime
      if (!raw) return '-'
      if (typeof raw === 'string') return raw.slice(0, 10)
      if (raw.year != null && raw.month != null && raw.day != null)
        return `${raw.year}-${String(raw.month).padStart(2, '0')}-${String(raw.day).padStart(2, '0')}`
      if (raw instanceof Date) return raw.toISOString().slice(0, 10)
      return String(raw).slice(0, 10)
    },
    async setHidden(item, value) {
      try {
        if (item._isAiBlog) {
          await this.$axios.patch(`/api/aiblog/${item.id}`, { hidden: value })
        } else {
          await this.$axios.patch(`/content/${item.id}`, { hidden: value })
        }
        item.hidden = value
      } catch (err) {
        alert('변경에 실패했습니다.')
        console.error(err)
      }
    },
    async setFeatured(item, value) {
      try {
        if (item._isAiBlog) {
          await this.$axios.patch(`/api/aiblog/${item.id}`, { featured: value })
        } else {
          await this.$axios.patch(`/content/${item.id}`, { featured: value })
        }
        item.featured = value
        if (item.isFeatured !== undefined) item.isFeatured = value
      } catch (err) {
        alert('변경에 실패했습니다.')
        console.error(err)
      }
    },
    openCreatePage(){
      this.$router.push({name: 'adminContent', params: {type: 'create'}})
    },
    openBlogCreatePage(){
      this.$router.push({name: 'adminContent', params: {type: 'create'}, query: {category: 'BLOG'}})
    },
  },
  mounted() {
    if(!this.$store.state.isAdmin){
      alert('관리자 권한 없음')
      this.$router.push({path: '/'})
    }
    this.getNewsContents()
  },
}
</script>

<style lang="scss" src="./console.scss"></style>